import Utils from "./Utils";
import AxL from "./axl";
export default class ShareManager {
  constructor(axl, tracker) {
    this.axl = axl;
    this.tracker = tracker;
    this.shareData = {};
    // this.setup(b64Image, axl.can.shareFiles);
  }

  set translations(file) {
    this._translations = file;
  }

  send(b64Image) {
    console.log("send image", b64Image, this.axl);
    this.setupAndSend(b64Image, AxL.can["shareFiles"]);
  }

  async setupAndSend(b64Image, canshare) {
    // const b64Image = await Utils.addWaterMark(
    //   `${GLOBAL_PATH}images/logo.png`,
    //   _b64Image,
    //   512,
    //   512
    // );
    // upload image on bucket
    const data = await Utils.sendToBucket(`${GLOBAL_PATH}share`, b64Image);
    // get an id
    const id = data.id;
    // share that id
    this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
      imageID: id,
    });
    //
    if (canshare) {
      this.shareData = {
        title: this._translations.share_title,
        text: this._translations.share_p,
        files: [
          {
            data: b64Image.split(",")[1],
            name: "GigaMangaCreation.png",
            type: "image/png",
          },
        ],
      };

      if (this.axl) {
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "share_b64_image",
          nonInteraction: true,
        });
      }
    } else {
      // // upload image on bucket
      // const data = await Utils.sendToBucket(`${GLOBAL_PATH}share`, b64Image);
      // //   console.log(data);
      // // get an id
      // const id = data.id;
      // // share that id
      // this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
      //   imageID: id,
      // });
      this.shareData = {
        title: this._translations.share_title,
        text: this._translations.share_p,
      };
      //
      // if (this.axl) {
      //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
      //     action: "share_url",
      //     nonInteraction: true,
      //   });
      // }
      // if (this.tracker) this.tracker.track("share");
    }

    this._send();
  }

  _send() {
    this.axl.sendMessage(AxL.ChildToHost.SHARE, this.shareData);
  }
}
